<!-- Colorbar at top -->
<lib-ds-colorbar></lib-ds-colorbar>

<!-- Main login container -->
<div class="ds-login-container" [class.has-background]="!!backgroundColor" [style.background-color]="backgroundColor">
  <div class="ds-login-content">
    <!-- Info notice banner (outside card for shelter) -->
    <lib-ds-info-banner
      *ngIf="showInfoBanner && !backgroundColor"
      [text]="infoBannerText"
      [linkText]="infoBannerLinkText"
      [linkUrl]="infoBannerLinkUrl"
      [iconSrc]="infoBannerIcon"
    ></lib-ds-info-banner>

    <!-- Login form wrapper - card for staff, form-container for shelter -->
    <div [class.ds-login-card]="!!backgroundColor" [class.ds-login-form-container]="!backgroundColor">
      <!-- Info notice banner (inside card for staff) -->
      <lib-ds-info-banner
        *ngIf="showInfoBanner && backgroundColor"
        [text]="infoBannerText"
        [linkText]="infoBannerLinkText"
        [linkUrl]="infoBannerLinkUrl"
        [iconSrc]="infoBannerIcon"
      ></lib-ds-info-banner>

      <!-- Login title -->
      <h1 class="ds-login-title">{{ loginTitle }}</h1>

      <!-- Login form -->
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
        <!-- Username field -->
        <lib-ds-form-field
          [label]="'Username'"
          [type]="'text'"
          [id]="usernameFieldId"
          [placeholder]="'name@example.com'"
          [autocomplete]="'email'"
          [required]="true"
          [hasError]="submitted && !!loginForm.controls['username'].errors"
          [errorMessage]="submitted && loginForm.controls['username'].errors?.['required'] ? 'Username is required.' : undefined"
          formControlName="username"
          (inputChange)="clearUsernameError()"
        ></lib-ds-form-field>

        <!-- Password field -->
        <lib-ds-form-field
          [label]="'Password'"
          [type]="'password'"
          [id]="passwordFieldId"
          [placeholder]="'Password'"
          [required]="true"
          [hasError]="submitted && !!loginForm.controls['password'].errors"
          [errorMessage]="submitted && loginForm.controls['password'].errors?.['required'] ? 'Password is required.' : undefined"
          [showPasswordToggle]="true"
          formControlName="password"
          (inputChange)="clearPasswordError()"
        >
          <a 
            *ngIf="forgotPasswordUrl"
            [href]="isExternalLink(forgotPasswordUrl) ? forgotPasswordUrl : null"
            [routerLink]="isRouterLink(forgotPasswordUrl) ? forgotPasswordUrl : null"
            class="ds-login-forgot-password"
          >
            Forgot password?
          </a>
        </lib-ds-form-field>

        <!-- Error notice for bad credentials -->
        <lib-ds-notice
          *ngIf="submitted && (error$ | async) === 'Invalid credentials'"
          [message]="'The username or password you entered was incorrect.'"
          type="error"
          (dismiss)="onDismissError()"
        ></lib-ds-notice>

        <!-- Error notice for network/server issues -->
        <lib-ds-notice
          *ngIf="(error$ | async) === 'Network error'"
          [message]="'Unable to sign in. Please try again shortly.'"
          type="error"
          (dismiss)="onDismissError()"
        ></lib-ds-notice>

        <!-- Sign in button -->
        <button 
          type="submit" 
          class="ds-login-sign-in-button"
          [disabled]="isLoading$ | async"
          [attr.aria-busy]="isLoading$ | async">
          <lib-new-loading *ngIf="isLoading$ | async"></lib-new-loading>
          <span *ngIf="!(isLoading$ | async)">SIGN IN</span>
        </button>
      </form>
    </div>

    <!-- Petszel logo -->
    <img [src]="logoSrc" alt="Petszel" class="ds-login-petszel-logo" />
  </div>
</div>

<!-- Footer CTA -->
<div class="ds-login-footer-cta" *ngIf="showFooterCta">
  <img 
    *ngIf="footerCtaIcon" 
    [src]="footerCtaIcon" 
    alt="" 
    class="ds-login-shelter-icon"
  />
  <svg 
    *ngIf="!footerCtaIcon" 
    class="ds-login-shelter-icon" 
    width="32" 
    height="32" 
    viewBox="0 0 32 32" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 4L4 12V28H28V12L16 4ZM16 8L24 14V24H8V14L16 8Z" fill="#46C2C9"/>
  </svg>
  <p class="ds-login-footer-text">
    <strong *ngIf="footerCtaText">{{ footerCtaText }}</strong>
    <br *ngIf="footerCtaLinkText">
    <a 
      *ngIf="footerCtaLinkUrl && footerCtaLinkText"
      [href]="isExternalLink(footerCtaLinkUrl) ? footerCtaLinkUrl : null"
      [routerLink]="isRouterLink(footerCtaLinkUrl) ? footerCtaLinkUrl : null"
      class="ds-login-footer-link"
    >
      {{ footerCtaLinkText }}
    </a>
  </p>
</div>
